import React, { useEffect } from "react";
import * as WidgetUtils from "../logic/WidgetUtils";
import * as Constants from "../logic/Constants";

// Externals
import cn from "classnames";

// DevExtreme components
import DataGrid, { Column, Editing } from 'devextreme-react/data-grid';
import { Toolbar, Item } from 'devextreme-react/toolbar';

// Component styles
import classes from "./StringListWidget.module.scss";

export function StringListWidget(props) {
  const { ui, config, data, writeBack, startWork, doAction } = props;
  const widgetId = ui.id;

  let dataGridSelector;

  let disabled = ui.readonly || (data && data.readonly);
  let content = data && data.content ? JSON.parse(data.content) : null;
  let items = content && content.Items ? content.Items : [];
  let toolbarButtons = config && config.Buttons ? config.Buttons : [];

  let toolbarHeight = Constants.DEFAULT_ROW_HEIGHT + "em";
  let tableHeight = "calc(100% - " + toolbarHeight + ")";

  function createDataSource() {
    //items.push("");   //for new entries
    return items.map((row, i) => {
      return { "rowId": i, "content": row };
    });
  };

  useEffect(() => {
    console.log("StringListWidget data of " + ui.id + ": ", data);
  }, [data]);

  const findIcon = actionId => {
    switch (actionId) {
      case Constants.STRINGLIST_WIDGET_NEW_ITEM_ACTION:
        return "plus";
      case Constants.STRINGLIST_WIDGET_DELETE_ITEM_ACTION:
        return "close";
      case Constants.STRINGLIST_WIDGET_MOVEUP_ACTION:
        return "arrowup";
      case Constants.STRINGLIST_WIDGET_MOVEDOWN_ACTION:
        return "arrowdown";
      default:
        return <React.Fragment />;
    }
  };

  const onRowUpdated = (event) => {
    //console.log("Row Changed", event);
    let value = JSON.stringify({ Index: event.data.rowId, Value: event.data.content });
    writeBack(value, true);
  };

  const onSelectionChanged = (event) => {
    let rowId = event.selectedRowKeys[0].toString();
    doAction(Constants.STRINGLIST_WIDGET_SELECT_ITEM_ACTION, rowId);
  };

  const onActionButtonClick = async (event, actionId) => {
    doAction(actionId);           //do not use await here otherwise 'dataGridSelector' is null
    afterButtonAction(actionId);   
  };

  const afterButtonAction = (actionId) => {
    switch (actionId) {
      case Constants.STRINGLIST_WIDGET_NEW_ITEM_ACTION:
        break;
      case Constants.STRINGLIST_WIDGET_DELETE_ITEM_ACTION:
        break;
      case Constants.STRINGLIST_WIDGET_MOVEUP_ACTION:
        if (dataGridSelector) {
          let selectedIndex = dataGridSelector.instance.getSelectedRowKeys()[0];
          dataGridSelector.instance.selectRowsByIndexes([selectedIndex-1]);
        }
        break;
      case Constants.STRINGLIST_WIDGET_MOVEDOWN_ACTION:
        if (dataGridSelector) {
          let selectedIndex = dataGridSelector.instance.getSelectedRowKeys()[0];
          dataGridSelector.instance.selectRowsByIndexes([selectedIndex+1]);
        }
        break;
      default:
        return <React.Fragment />;
    }
  }

  const renderTableLabel = () => {
    return (
      <Item
        key={'tableLabel'}
        text={WidgetUtils.toCleanText(ui.label)}
        location="before"
      />
    );
  };

  const renderActionButton = (control) => {
    return (
      <Item
        key={control.ActionId}
        widget="dxButton"
        location="after"
        disabled={disabled}
        options={{
          icon: findIcon(control.ActionId),
          hint: control.Tooltip,
          stylingMode: "text",
          onClick: e => onActionButtonClick(e, control.ActionId)
        }}
      />
    );
  };

  const renderCommandBar = () => {
    return (
      <Toolbar className={cn(classes.toolbar, "dx-theme-border-color")} style={{height: toolbarHeight}}>
        {renderTableLabel()}
        {toolbarButtons.map(control => (
          renderActionButton(control)
        ))}
      </Toolbar>
    );
  };

  const renderTable = () => {
    return (
      <DataGrid
        dataSource={createDataSource()}
        showBorders={true}
        showColumnLines={false}
        showRowLines={true}
        rowAlternationEnabled={true}
        hoverStateEnabled={true}
        showColumnHeaders={false}
        selection={{ mode: "single" }}
        //scrolling={{ showScrollbar: "always" }}  //has a layout bug at the moment :-(
        keyExpr="rowId"
        //selectedRowKeys={[selectedIndex]}
        onSelectionChanged={(e) => onSelectionChanged(e)}
        onEditingStart={() => startWork()}
        onRowUpdated={(e) => onRowUpdated(e)}
        ref={el => dataGridSelector = el}
        style={{height: tableHeight}}
      >
        <Editing
          mode="cell"
          allowUpdating={disabled === false}
          //selectTextOnEditStart={true}
          startEditAction={"dblClick"}
        />

        <Column
          key="content"
          dataField="content"
          alignment="left"
          dataType="string"
          width="100%"
        />
      </DataGrid>
    );
  };

  return config ? (
    <div className={classes.wrapper} id={widgetId}>
      {renderCommandBar()}
      {renderTable()}
    </div>
  ) : null;
}
